module.exports = __webpack_public_path__ + "static/img/3.c65d2ca0.png";